import Swiper from 'swiper';
export default function accountTrySomethingNew() {
    return {
        swiper: null,
        sliderPerViewDesktop: null,
        init() {
            this.$nextTick(() => {
                    this.initSwiperSlider();
            });
        },

        initSwiperSlider() {
            this.sliderPerViewDesktop = this.$refs.trySomethingNewSwiper.getAttribute('data-slider-per-view-desktop');
            this.swiper = new Swiper(this.$refs.trySomethingNewSwiper, {
                loop: true,
                centeredSlides: true,
                slidesPerView: 1,
                spaceBetween: 10,
                updateOnWindowResize: true,
                navigation: {
                    nextEl: this.$refs.rightArrow,
                    prevEl: this.$refs.leftArrow,
                },
                breakpoints: {
                    1200: {
                        loop: false,
                        centeredSlides: false,
                        slidesPerView: this.sliderPerViewDesktop || 2,
                        spaceBetween: 10
                    }
                },
            });
        }
    }
}